var _g, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyncStatusBanner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 236,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sync-status-banner_svg__a)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-status-banner_svg__b)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("rect", {
  width: 237.687,
  height: 191.774,
  x: 20,
  y: 21.852,
  fill: "#008060",
  rx: 95.887
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-status-banner_svg__c)",
  opacity: 0.1,
  style: {
    mixBlendMode: "multiply"
  }
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 108.97,
  height: 107.074,
  x: 32.776,
  y: 66.6,
  fill: "#3D2800",
  rx: 7.313
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 119.209,
  height: 88.571,
  x: 20.164,
  y: 67.269,
  fill: "#fff",
  stroke: "#ECECEC",
  strokeWidth: 1.463,
  rx: 3.535
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7E92",
  d: "M27.203 75.939a2.103 2.103 0 1 0 0-4.206 2.103 2.103 0 0 0 0 4.206"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD05B",
  d: "M34.212 75.939a2.103 2.103 0 1 0 0-4.206 2.103 2.103 0 0 0 0 4.206"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#98DB7C",
  d: "M41.22 75.939a2.103 2.103 0 1 0 0-4.206 2.103 2.103 0 0 0 0 4.206"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M105 71.733H48.93a2.103 2.103 0 1 0 0 4.206H105a2.103 2.103 0 0 0 0-4.206"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  d: "M130.231 80.444H29.306c-.774 0-1.402.628-1.402 1.402V95.22c0 .774.628 1.402 1.402 1.402H130.23c.774 0 1.402-.628 1.402-1.402V81.846c0-.774-.628-1.402-1.402-1.402"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8E9EB",
  d: "M46.127 99.11H29.306c-.774 0-1.402.628-1.402 1.402v46.973c0 .774.628 1.401 1.402 1.401h16.82c.775 0 1.402-.627 1.402-1.401v-46.973c0-.774-.627-1.402-1.401-1.402M130.231 99.11H51.734c-.775 0-1.402.628-1.402 1.402v1.552c0 .774.627 1.402 1.402 1.402h78.497c.774 0 1.402-.628 1.402-1.402v-1.552c0-.774-.628-1.402-1.402-1.402M67.153 105.954h-15.42c-.773 0-1.401.628-1.401 1.402v15.419c0 .774.627 1.402 1.402 1.402h15.419c.774 0 1.402-.628 1.402-1.402v-15.419c0-.774-.628-1.402-1.402-1.402M88.179 105.954h-15.42c-.773 0-1.401.628-1.401 1.402v15.419c0 .774.628 1.402 1.402 1.402h15.419c.774 0 1.402-.628 1.402-1.402v-15.419c0-.774-.628-1.402-1.402-1.402M109.205 105.954h-15.42c-.773 0-1.4.628-1.4 1.402v15.419c0 .774.627 1.402 1.4 1.402h15.42c.774 0 1.402-.628 1.402-1.402v-15.419c0-.774-.628-1.402-1.402-1.402M67.153 124.62h-15.42c-.773 0-1.401.628-1.401 1.402v15.419c0 .774.627 1.402 1.402 1.402h15.419c.774 0 1.402-.628 1.402-1.402v-15.419c0-.774-.628-1.402-1.402-1.402M88.179 124.62h-15.42c-.773 0-1.401.628-1.401 1.402v15.419c0 .774.628 1.402 1.402 1.402h15.419c.774 0 1.402-.628 1.402-1.402v-15.419c0-.774-.628-1.402-1.402-1.402M109.205 124.62h-15.42c-.773 0-1.4.628-1.4 1.402v15.419c0 .774.627 1.402 1.4 1.402h15.42c.774 0 1.402-.628 1.402-1.402v-15.419c0-.774-.628-1.402-1.402-1.402"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  d: "M96.59 144.53H84.675c-.774 0-1.402.628-1.402 1.402v1.552c0 .774.628 1.402 1.402 1.402H96.59c.774 0 1.401-.628 1.401-1.402v-1.552c0-.774-.627-1.402-1.401-1.402M79.068 144.53h-2.103c-.774 0-1.402.628-1.402 1.402v1.552c0 .774.628 1.402 1.402 1.402h2.103c.774 0 1.401-.628 1.401-1.402v-1.552c0-.774-.627-1.402-1.401-1.402"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAFBFB",
  d: "M25 79.167c0-.774.628-1.401 1.402-1.401H105v72.282c0 .774-.628 1.401-1.402 1.401H25z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M92.113 104.303c0-6.499-5.998-11.786-13.37-11.786-1.163 0-2.313.13-3.418.388l-2.38.554-1.057-1.961c-1.879-3.489-5.914-5.743-10.28-5.743-6.27 0-11.371 4.497-11.371 10.025v3.51h-4.092c-8.266 0-15.098 5.843-15.145 13.13-.047 7.318 6.691 13.284 14.98 13.284h44.07c6.048 0 10.95-4.322 10.95-9.653 0-4.658-3.947-8.502-9.053-9.078l.14-1.934q.026-.37.026-.736"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#73C0AE",
  d: "M83.239 38.235a1.999 1.999 0 1 0 4 0 1.999 1.999 0 1 0-4 0"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M75.843 103H56.157A9.157 9.157 0 0 0 47 112.157v19.686C47 136.9 51.1 141 56.157 141h19.686C80.9 141 85 136.9 85 131.843v-19.686C85 107.1 80.9 103 75.843 103"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#00A47C",
  d: "M75.843 101H56.157A9.157 9.157 0 0 0 47 110.157v19.686C47 134.9 51.1 139 56.157 139h19.686C80.9 139 85 134.9 85 129.843v-19.686C85 105.1 80.9 101 75.843 101"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M65.849 111.978c2.11 0 4.107.724 5.759 2.041l-3.823 3.779 9.723 1.094-.457-10.255-3.877 3.833c-2.068-1.76-4.626-2.72-7.325-2.72-6.433 0-11.667 5.496-11.667 12.25h2.121c0-5.527 4.282-10.022 9.546-10.022M65.848 132.023c-2.11 0-4.108-.724-5.76-2.042l3.823-3.778-9.722-1.095.457 10.256 3.876-3.833c2.069 1.759 4.627 2.719 7.326 2.719 6.433 0 11.667-5.496 11.667-12.25h-2.121c0 5.527-4.282 10.023-9.546 10.023"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M65.849 110.068c2.11 0 4.107.724 5.759 2.042l-3.823 3.778 9.723 1.095-.457-10.255-3.877 3.833c-2.068-1.76-4.626-2.72-7.325-2.72-6.433 0-11.667 5.496-11.667 12.25h2.121c0-5.527 4.282-10.023 9.546-10.023M65.848 130.114c-2.11 0-4.108-.724-5.76-2.042l3.823-3.778-9.722-1.095.457 10.256 3.876-3.834c2.069 1.76 4.627 2.72 7.326 2.72 6.433 0 11.667-5.496 11.667-12.25h-2.121c0 5.527-4.282 10.023-9.546 10.023"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "sync-status-banner_svg__b",
  width: 302.736,
  height: 256.824,
  x: -12.525,
  y: -10.673,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_13789_27761",
  stdDeviation: 16.262
})), /*#__PURE__*/React.createElement("filter", {
  id: "sync-status-banner_svg__c",
  width: 130.91,
  height: 129.015,
  x: 21.806,
  y: 55.63,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_13789_27761",
  stdDeviation: 5.485
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "sync-status-banner_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h100v228a8 8 0 0 1-8 8H0z"
})))));
export { SvgSyncStatusBanner as ReactComponent };
export default __webpack_public_path__ + "static/media/sync-status-banner.79f53c88.svg";